/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { DatasourceConfigBase } from './DatasourceConfigBase';
import { DatasourceConfigBaseFromJSON, DatasourceConfigBaseFromJSONTyped, DatasourceConfigBaseToJSON, } from './DatasourceConfigBase';
import type { DatasourcePurpose } from './DatasourcePurpose';
import { DatasourcePurposeFromJSON, DatasourcePurposeFromJSONTyped, DatasourcePurposeToJSON, } from './DatasourcePurpose';
import type { S3Region } from './S3Region';
import { S3RegionFromJSON, S3RegionFromJSONTyped, S3RegionToJSON, } from './S3Region';
/*
causes circular dependendies
// .concat(DatasourceConfigBaseValidator)

*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DatasourceConfigS3DelegatedAccess
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId")("string")(() => {
    const regex = new RegExp(/^[a-zA-Z0-9_+=,.@:\/-]+$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_DatasourceConfigS3DelegatedAccess_s3ARN")("string")(() => {
    const regex = new RegExp(/^arn:aws:iam::[0-9]{12}:role.+$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey")("string")(() => {
    const regex = new RegExp(/^arn:aws:kms:[a-zA-Z0-9-]*:[0-9]{12}:key.+$/);
    return (value: string) => !!regex.exec(value);
});
export interface DatasourceConfigS3DelegatedAccess extends DatasourceConfigBase {
    /**
     * path includes the bucket name and the path within the bucket where you have stored your information
     * #type string
     * #memberof DatasourceConfigS3DelegatedAccess
        
        
         */
    fullPath: string;
    /**
     *
     * #type S3Region
     * #memberof DatasourceConfigS3DelegatedAccess
        
        
         */
    s3Region: S3Region;
    /**
     * The external ID specified when creating the role.
     * More information can be found here:
     * - https://docs.aws.amazon.com/IAM/latest/UserGuide/confused-deputy.html
     * - https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_externalid
     * #type string
     * #memberof DatasourceConfigS3DelegatedAccess
        
        
    * @pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId
    * @minLength 10
         */
    s3ExternalId: string;
    /**
     * The ARN of the role you created
     * #type string
     * #memberof DatasourceConfigS3DelegatedAccess
        
        
    * @pattern_DatasourceConfigS3DelegatedAccess_s3ARN
    * @minLength 12
         */
    s3ARN: string;
    /**
     * If set, Lightly Worker will automatically set the headers to use server side encryption
     * https://docs.aws.amazon.com/AmazonS3/latest/userguide/UsingKMSEncryption.html
     * with this value as the appropriate KMS key arn.
     * This will encrypt the files created by Lightly (crops, frames, thumbnails) in the S3 bucket.
     * #type string
     * #memberof DatasourceConfigS3DelegatedAccess
        
        
    * @pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey
    * @minLength 1
         */
    s3ServerSideEncryptionKMSKey?: string;
}
/**
 * Check if a given object implements the DatasourceConfigS3DelegatedAccess interface.
 */
export function instanceOfDatasourceConfigS3DelegatedAccess(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fullPath" in value;
    isInstance = isInstance && "s3Region" in value;
    isInstance = isInstance && "s3ExternalId" in value;
    isInstance = isInstance && "s3ARN" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { DatasourceConfigBaseValidator, DatasourceConfigBaseStringifyShape, DatasourceConfigBaseStringifyShapeProperties, } from './DatasourceConfigBase';
import { DatasourcePurposeValidator, DatasourcePurposeStringifyShape, DatasourcePurposeStringifyShapeProperties, } from './DatasourcePurpose';
import { S3RegionValidator, S3RegionStringifyShape, S3RegionStringifyShapeProperties, } from './S3Region';
export const DatasourceConfigS3DelegatedAccessTypiaAssertEquals = (input: any) => {
    return ((input: any): DatasourceConfigS3DelegatedAccess => {
        const __is = (input: any, _exceptionable: boolean = true): input is DatasourceConfigS3DelegatedAccess => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3ExternalId && 10 <= input.s3ExternalId.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId)) && ("string" === typeof input.s3ARN && 12 <= input.s3ARN.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN)) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && "string" === typeof input.type && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (6 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["fullPath", "s3Region", "s3ExternalId", "s3ARN", "s3ServerSideEncryptionKMSKey", "id", "purpose", "type", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasourceConfigS3DelegatedAccess => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region || $guard(_exceptionable, {
                    path: _path + ".s3Region",
                    expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                    value: input.s3Region
                })) && ("string" === typeof input.s3ExternalId && (10 <= input.s3ExternalId.length || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string (@minLength 10)",
                    value: input.s3ExternalId
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId) || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId)",
                    value: input.s3ExternalId
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string",
                    value: input.s3ExternalId
                })) && ("string" === typeof input.s3ARN && (12 <= input.s3ARN.length || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string (@minLength 12)",
                    value: input.s3ARN
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN) || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ARN)",
                    value: input.s3ARN
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string",
                    value: input.s3ARN
                })) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && (1 <= input.s3ServerSideEncryptionKMSKey.length || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@minLength 1)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "(string | undefined)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && ("string" === typeof input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "string",
                    value: input.type
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (6 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["fullPath", "s3Region", "s3ExternalId", "s3ARN", "s3ServerSideEncryptionKMSKey", "id", "purpose", "type", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceConfigS3DelegatedAccess",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceConfigS3DelegatedAccess",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DatasourceConfigS3DelegatedAccessTypiaAssertStringify = (input: DatasourceConfigS3DelegatedAccess): string => {
    return ((input: any): string => { const assert = (input: any): DatasourceConfigS3DelegatedAccess => {
        const __is = (input: any): input is DatasourceConfigS3DelegatedAccess => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3ExternalId && 10 <= input.s3ExternalId.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId)) && ("string" === typeof input.s3ARN && 12 <= input.s3ARN.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN)) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && "string" === typeof input.type && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasourceConfigS3DelegatedAccess => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region || $guard(_exceptionable, {
                    path: _path + ".s3Region",
                    expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                    value: input.s3Region
                })) && ("string" === typeof input.s3ExternalId && (10 <= input.s3ExternalId.length || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string (@minLength 10)",
                    value: input.s3ExternalId
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId) || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId)",
                    value: input.s3ExternalId
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string",
                    value: input.s3ExternalId
                })) && ("string" === typeof input.s3ARN && (12 <= input.s3ARN.length || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string (@minLength 12)",
                    value: input.s3ARN
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN) || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ARN)",
                    value: input.s3ARN
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string",
                    value: input.s3ARN
                })) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && (1 <= input.s3ServerSideEncryptionKMSKey.length || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@minLength 1)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "(string | undefined)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && ("string" === typeof input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "string",
                    value: input.type
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceConfigS3DelegatedAccess",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceConfigS3DelegatedAccess",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DatasourceConfigS3DelegatedAccess): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.s3ServerSideEncryptionKMSKey ? "" : `"s3ServerSideEncryptionKMSKey":${undefined !== input.s3ServerSideEncryptionKMSKey ? $string(input.s3ServerSideEncryptionKMSKey) : undefined},`}${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"fullPath":${$string(input.fullPath)},"s3Region":${(() => {
            if ("string" === typeof input.s3Region)
                return $string(input.s3Region);
            if ("string" === typeof input.s3Region)
                return "\"" + input.s3Region + "\"";
            $throws({
                expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                value: input.s3Region
            });
        })()},"s3ExternalId":${$string(input.s3ExternalId)},"s3ARN":${$string(input.s3ARN)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()},"type":${$string(input.type)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DatasourceConfigS3DelegatedAccessValidatorShape = {
    'fullPath': yup.string().defined().test('is-valid', 'the path needs to be set', (value) => {
        if (!value) {
            return false;
        }
        return true;
    })
        .test('is-valid', "It's not allowed to use '.lightly' in your path as its a reserved word used internally", (value) => {
        if (!value) {
            return true;
        }
        if (value.startsWith('.lightly/') ||
            value.endsWith('/.lightly') ||
            value.indexOf('/.lightly/') !== -1) {
            return false;
        }
        return true;
    })
        .test('is-valid', 'The path should not directly point to the location of the .lightly folder itself but to the .lightly folders parent', (value) => {
        if (!value) {
            return true;
        }
        if (value.endsWith('/.lightly/') || value.endsWith('/.lightly')) {
            return false;
        }
        return true;
    }),
    's3Region': S3RegionValidator.defined(),
    's3ExternalId': yup.string().matches(/^[a-zA-Z0-9_+=,.@:\/-]+$/).min(10).defined(),
    's3ARN': yup.string().matches(/^arn:aws:iam::[0-9]{12}:role.+$/).min(12).defined(),
    's3ServerSideEncryptionKMSKey': yup.string().matches(/^arn:aws:kms:[a-zA-Z0-9-]*:[0-9]{12}:key.+$/).min(1),
};
export const DatasourceConfigS3DelegatedAccessValidator = yup.object().shape(DatasourceConfigS3DelegatedAccessValidatorShape).concat(DatasourceConfigBaseValidator);
export const DatasourceConfigS3DelegatedAccessStringifyShapeProperties: ObjectSchema['properties'] = {
    'fullPath': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    's3Region': S3RegionStringifyShape,
    's3ExternalId': {
        'type': 'string',
        'pattern': "/^[a-zA-Z0-9_+&#x3D;,.@:\/-]+$/".slice(1, -1),
        'minLength': 10,
    } as unknown as fastJSON.StringSchema,
    's3ARN': {
        'type': 'string',
        'pattern': "/^arn:aws:iam::[0-9]{12}:role.+$/".slice(1, -1),
        'minLength': 12,
    } as unknown as fastJSON.StringSchema,
    's3ServerSideEncryptionKMSKey': {
        'type': 'string',
        'pattern': "/^arn:aws:kms:[a-zA-Z0-9-]*:[0-9]{12}:key.+$/".slice(1, -1),
        'minLength': 1,
    } as unknown as fastJSON.StringSchema,
};
export const DatasourceConfigS3DelegatedAccessStringifyShape: ObjectSchema = {
    title: 'DatasourceConfigS3DelegatedAccess Stringifier',
    type: 'object',
    properties: {
        ...DatasourceConfigBaseStringifyShapeProperties,
        ...DatasourceConfigS3DelegatedAccessStringifyShapeProperties
    },
    required: [
        ...(DatasourceConfigBaseStringifyShape.required ? DatasourceConfigBaseStringifyShape.required : []),
        'fullPath',
        's3Region',
        's3ExternalId',
        's3ARN',
    ],
};
export const DatasourceConfigS3DelegatedAccessStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DatasourceConfigS3DelegatedAccessStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DatasourceConfigS3DelegatedAccessStringify: (data: DatasourceConfigS3DelegatedAccess) => string = DatasourceConfigS3DelegatedAccessStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DatasourceConfigS3DelegatedAccessFromJSON(json: any): DatasourceConfigS3DelegatedAccess {
    return DatasourceConfigS3DelegatedAccessFromJSONTyped(json, false);
}
export function DatasourceConfigS3DelegatedAccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasourceConfigS3DelegatedAccess {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
    if (!ignoreDiscriminator) {
    }
*/
    return {
        ...DatasourceConfigBaseFromJSONTyped(json, ignoreDiscriminator),
        'fullPath': json['fullPath'],
        's3Region': S3RegionFromJSON(json['s3Region']),
        's3ExternalId': json['s3ExternalId'],
        's3ARN': json['s3ARN'],
        's3ServerSideEncryptionKMSKey': !exists(json, 's3ServerSideEncryptionKMSKey') ? undefined : json['s3ServerSideEncryptionKMSKey'],
    };
}
export function DatasourceConfigS3DelegatedAccessToJSON(value?: DatasourceConfigS3DelegatedAccess | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatasourceConfigBaseToJSON(value),
        'fullPath': value.fullPath,
        's3Region': S3RegionToJSON(value.s3Region),
        's3ExternalId': value.s3ExternalId,
        's3ARN': value.s3ARN,
        's3ServerSideEncryptionKMSKey': value.s3ServerSideEncryptionKMSKey,
    };
}
